const generator = require('./accountreconciliation-fullcont-multitable-generator')

export const accountreconciliationMT = [
	{
		tableName: 'accountreconciliation_vs_transactions',
		value: '',
		id: 'accountreconciliation_form_transactions',
		html: '',
		data: [],
		dataCopy: [],
		oneRequired: true,
		fields: [
			{
				name:      'transaction_id',
				type:      'textfield',
				html:      '',
				required:  true,
			},

			{
				name:      'entity_name',
				type:      'textfield',
				html:      '',
				required:  false,
			},

			{
				name:      'account_type',
				type:      'textfield',
				html:      '',
				required:  false,
			},

			{
				name:      'transaction_type',
				type:      'textfield',
				html:      '',
				required:  false,
			},

			{
				name:      'amount',
				type:      'textfield',
				html:      '',
				required:  false,
			},

			{
				name:      'date',
				type:      'textfield',
				html:      '',
				required:  false,
			},

			{
				name:      'selected',
				type:      'checkbox',
				html:      '',
				required:  false,
			},
		],
		generator: function(line) {
			return generator.transactions(line.id)
		},
	},
]
